<template>
  <div>
    <PatrimoniosList :idEvento="idEvento" :patrimonios="patrimonios" />
  </div>
</template>

<script>
import PatrimoniosList from '../../../shared/components/PatrimoniosList.vue';

export default {
  props: ['idEvento', 'patrimonios'],
  components: {
    PatrimoniosList,
  },
};
</script>
